// Componentes nativos
import React, { useState } from "react";
import axios from "axios";
import ReactLoading from "react-loading";

// Ícones
import { RiMailSendLine } from "react-icons/ri";

// Estilização
import "./style.css";

// Componentes personalizados
import Header from "../Header";

export default function Contato() {
    // Gerencia o conteúdo do email
    const [email, setEmail] = useState("");
    const [visivel, setVisivel] = useState(false);

    // Atualiza variável de estado
    function update(event: React.ChangeEvent<HTMLTextAreaElement>) {
        setEmail(event.target.value);
    }

    // Envia email
    async function send() {
        // Valida a quantidade de caracteres na mensagem
        if(email.length < 10) {
            alert("Escreva um pouquinho mais, pelo menos 10 caracteres. Por favor.");
            return;
        }

        setVisivel(true);
        try {
            // Envia para a api
            const res = await axios.post("https://priore.herokuapp.com/news/email", {
                origem: "Priore",
                mensagem: email
            });

            // Exibe mensagem
            alert("Seu e-mail foi enviado, agradeço pelo seu tempo e sua mensagem.");
            setEmail("");
            setVisivel(false);
        } catch(erro) {
            setVisivel(false);
            if(erro.response.data.message == undefined)
                alert("Desculpa, parece que não foi possível estabelecer uma conexão com o servidor e enviar o e-mail. Verifique a sua conexão de internet.");
            else
                alert(erro.response.data.message);
        }
    }

    return (
        <div className="section">
            <Header />

            <div className="content">

                <div className={visivel ? "loading-ativo" : "loading-none"}>
                    <ReactLoading color="#1a1a1a" type="spinningBubbles" />
                </div>

                <div className="container">
                    <h3>Entre em Contato</h3>

                    <p>Se quiser enviar alguma mensagem, seja uma crítica, um elogio ou uma sugestão, fico feliz em receber sua opinião. Criei Priore com o objetivo de ser útil para as pessoas, então adoraria o seu feedback. Só escrever o que deseja no espaço abaixo. Seu contato é completamente anônimo, eu recebo apenas o que você escrever na caixa de texto.</p>

                    <div className="caixa-contato">
                        <textarea id="email" className="input-contato" rows={10} value={email} onChange={update} />
                    </div>

                    <div className="linha-botao-contato">
                        <div className="botao-contato" onClick={send}>
                            <RiMailSendLine size={18} />
                            <span>Enviar</span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}